import { render, staticRenderFns } from "./ReportModalDelete.vue?vue&type=template&id=9a80154a&scoped=true&"
import script from "./ReportModalDelete.vue?vue&type=script&lang=js&"
export * from "./ReportModalDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a80154a",
  null
  
)

export default component.exports